module.exports = __webpack_public_path__ + "static/media/LR.42cb9ca0.png";